/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import actionTypes from "../../../store/actions";
import {
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Card,
  Select,
  MenuItem,
} from "@mui/material";
import classes from "./customers.module.css";
import Pagination from "@mui/material/Pagination";
import Button from "../../../component/button";
// import TextEditor from "../../../component/richTextEditor";
import TiptapEditor from "../../../component/richTextEditor/TiptapEditor";
import { getDraftContentStats } from "../../../component/richTextEditor/getContentStats";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromRaw,
  Modifier,
} from "draft-js";
import Input from "../../../component/inputpm";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  DetailView,
  ListView,
  ExpandAll,
} from "../../../component/icons/icons";
import { IconButton, Tooltip } from "@mui/material";
import { truncateEditorStateByCharLimit } from "../../../component/richTextEditor/truncateRichTextEditorChar";
import ShowFullEditorContent from "../../../component/richTextEditor/showFullEditorContent";
import { formatNumber } from "../../../helper/numberFormatter";
import { getStateName } from "../../../helper/getStateList";

const ManageCustomerTableView = (props) => {
  const t = props.t;

  const [customerList, setCustomerList] = useState([]);
  const [showMyCustomers, setShowMyCustomers] = useState(false);
  useEffect(() => {
    setCustomerList(props.customerList ? props.customerList : []);
    const storedShowMyCustomers = localStorage.getItem("showMyCustomers");
    setShowMyCustomers(
      storedShowMyCustomers === "true"
        ? true
        : storedShowMyCustomers === "false"
          ? false
          : props.showMyCustomersEnabled === true,
    );
  }, []);
  const setEditorState = (data) => {
    var initialData = JSON.parse(data.customerNote);
    var finalData = convertFromRaw(initialData);
    var tempState = EditorState.createWithContent(finalData);
    // return tempState;
    // return truncateEditorStateByWordLimit(tempState, 80);
    return truncateEditorStateByCharLimit(tempState, 500);
  };
  // const getWordCount = (data) => {
  //   var initialData = JSON.parse(data.customerNote);
  //   var finalData = convertFromRaw(initialData);
  //   var tempState = EditorState.createWithContent(finalData);

  //   const content = tempState.getCurrentContent();
  //   const plainText = content.getPlainText();

  //   let truncatedText = plainText;
  //   if (plainText.length > 500) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };
  const [showDescription, setShowDescription] = useState(false);
  // const [descriptionData, setDescriptionData] = useState({});
  const [descriptionData, setDescriptionData] = useState('{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}');
  const showFullDescription = (data) => {
    // var initialData = JSON.parse(data.customerNote);
    // var finalData = convertFromRaw(initialData);
    // var tempState = EditorState.createWithContent(finalData);
    // setDescriptionData(data.customerNote);
    setDescriptionData(data);
    setShowDescription(true);
  };
  const closeDescriptionDialog = () => {
    // setDescriptionData({});
    setDescriptionData('{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}');
    setShowDescription(false);
  };
  
  const [stateNamesMap, setStateNamesMap] = useState({});

  useEffect(() => {
    const fetchStateNames = async () => {
      const pairs = new Set();
      (props.customerList || []).forEach((c) => {
        const s = c.shipping?.[0];
        if (s?.country && s?.state) pairs.add(`${s.country}|${s.state}`);
      });
      const map = {};
      await Promise.all(
        [...pairs].map(async (key) => {
          const [country, state] = key.split("|");
          try {
            map[key] = await getStateName(country, state, props.providerType === "SOLUTION_PROVIDER" ? { tenantId: props.tenant } : {});
          } catch {
            map[key] = state;
          }
        })
      );
      setStateNamesMap((prev) => ({ ...prev, ...map }));
    };
    fetchStateNames();
    setCustomerRootNodes(props.customerList.filter((c) => c.level === 1));
  }, [props.customerList]);

  const getCountryName = (code, countriesList) => {
    if (!code || !countriesList?.length) return code || "";
    const found = countriesList.find((a) => a.id === code || a.abbreviation === code);
    return found ? found.name : code;
  };

  const formatShippingAddress = (shipping, countriesList, stateNamesMap = {}) => {
    if (!shipping?.[0]) return "";
    const s = shipping[0];
    const stateKey = s.country && s.state ? `${s.country}|${s.state}` : null;
    
    const stateDisplay = stateKey
  ? (stateNamesMap[stateKey] ?? "…")
  : null;
    
    const isBlank = (val) => !val || String(val).trim() === "" || String(val).trim() === "-";
    const countryDisplay = getCountryName(s.country, countriesList);
    const parts = [
      s.attention,
      [s.street1,s.street2].filter(Boolean).join(", "),
      [s.city,stateDisplay].filter(Boolean).join(", "),
      [s.zip,countryDisplay].filter(Boolean).join(", "),
      // s.phone,
    ].filter((v) => v != null && !isBlank(v)).map((v) => String(v).trim());
    return parts.join("\n");
  };

  const [customerRootNodes, setCustomerRootNodes] = useState([]);
  const [showListViewAllCustomers, setShowListViewAllCustomers] = useState(false);
  const toggleListViewAllCustomers = () => {
    setShowListViewAllCustomers(!showListViewAllCustomers);
  };

  return (
    <React.Fragment>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ marginBottom: ".5rem" }}>
          {/* Search filters start */}
          <div className={classes.searchOuterDiv}>
            {props.providerType === "SOLUTION_PROVIDER" && (
              <div className={classes.searchInputDiv}>
                <Select
                  style={{ width: "100%", marginBottom: "10px" }}
                  native
                  size={"small"}
                  variant={"outlined"}
                  name={"tenant"}
                  inputProps={{
                    name: "tenant",
                    id: "outlined-native-tenant",
                  }}
                  //value={(a) => a.value}
                  value={props.tenant}
                  onChange={(e) => {
                    props.onChange(e);
                  }}
                  onKeyDown={(e) => {
                    props.onSearchKeyDown(e);
                  }}
                  disabled={props.parentTenantId && props.screen !== "orders"}
                  selectClass={
                    classes.inputClass +
                    " " +
                    classes.statusSelectBg +
                    " " +
                    classes.searchOrderSelect
                  }
                >
                  {props.tenantList.map((a) => (
                    <option key={a.tenantId} value={a.tenantId}>
                      {a.tenantName}
                    </option>
                  ))}
                </Select>
              </div>
            )}
            {props.providerType != "SOLUTION_PROVIDER" && (
              <div className={classes.searchInputDiv}>
                <Select
                  native
                  size={"small"}
                  variant={"outlined"}
                  name={"showMyCustomers"}
                  inputProps={{
                    name: "showMyCustomers",
                    id: "outlined-native-showMyCustomers",
                  }}
                  //value={(a) => a.value}
                  value={showMyCustomers}
                  onChange={props.toggleShowMyCustomers}
                  // disabled={this.props.parentTenantId}
                  selectClass={
                    classes.inputClass +
                    " " +
                    classes.statusSelectBg +
                    " " +
                    classes.searchOrderSelect
                  }
                  style={{ width: "200px" }}
                >
                  <option value="true">{ props.pathname === "/manageLeads" ? t("MY_LEADS") : t("MY_CUSTOMERS")}</option>
                  <option value="false">{ props.pathname === "/manageLeads" ? t("ALL_LEADS") : t("ALL_CUSTOMERS")}</option>
                </Select>
              </div>
            )}
            <div className={classes.searchInputDiv}>
              <Input
                size={"small"}
                variant={"outlined"}
                placeholder={ props.pathname === "/manageLeads" ? t("SEARCH_BY_LEAD_NAME") : t("SEARCH_BY_NAME")}
                value={props.name}
                name={"name"}
                onChange={(e) => {
                  props.onSearchChange(e);
                }}
                divClass={classes.inputClass}
                onKeyDown={(e) => {
                  props.onSearchKeyDown(e);
                }}
                style={{ width: "200px" }}
              />
            </div>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <Tooltip title={t("SEARCH")}>
                <IconButton
                  className="iconButtonSecondary"
                  onClick={props.filterHierarchy}
                >
                  <SearchIcon />
                </IconButton>
              </Tooltip>{" "}
              &nbsp;
              <Tooltip title={t("CLEAR")}>
                <IconButton
                  className="iconButtonSecondary"
                  onClick={props.clearHierarchyFilters}
                >
                  <ClearIcon />
                </IconButton>
              </Tooltip>
              {props.pathname === '/manageCustomers' && 
                <>
                 &nbsp;
                  <Tooltip title={showListViewAllCustomers ? t("SHOW_ROOT_CUSTOMERS") : t("SHOW_ALL_CUSTOMERS")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={() => toggleListViewAllCustomers()}
                    >
                      <ExpandAll />
                    </IconButton>
                  </Tooltip>
                </>
              }
            </div>
          </div>
        </div>
      </div>
      <Card
        variant="outlined"
        style={{ borderRadius: "8px", marginBottom: "40px" }}
      >
        <TableContainer>
          <Table
            className={classes.table + " " + "newGlobalTable"}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell>{t("ACCOUNT_NAME")}</TableCell>
                <TableCell>{ props.pathname === "/manageLeads" ? t("OPPORTUNITY_DESCRIPTION") : t("BAN")}</TableCell>
                <TableCell>{ props.pathname === "/manageLeads" ? t("LEAD_CONTACT_&_ROLE") : t("CONTACT")}</TableCell>
                {/* <TableCell>{t('ROLE')}</TableCell>
                                <TableCell>{t('EMAIL')}</TableCell> */}
                { props.pathname === "/manageLeads" && <TableCell>{t("SECTOR")}</TableCell> }
                <TableCell>{ props.pathname === "/manageLeads" ? t("LOCATION") : t("SHIPPING_ADDRESS")}</TableCell>
                {/* <TableCell>{t('PHONE')}</TableCell> */}
                <TableCell>{t("ACTIONS")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {(() => {
              const displayList = showListViewAllCustomers ? props.customerList : customerRootNodes;
              return displayList && displayList.length > 0 ? (
                displayList.map((customer, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ verticalAlign: "top" }}>
                      {customer.accountName}
                    </TableCell>
                    <TableCell
                      style={{ verticalAlign: "top" }}
                      // className="noPaddingClassOnColumn"
                    >
                      { props.pathname === "/manageCustomers" ? customer.ban : 
                      (customer.customerNote &&
                        customer.customerNote.customerNote &&
                        customer.customerNote.customerNote !== "" && (
                          <>
                            {/* <TiptapEditor
                              value={customer.customerNote.customerNote}
                              readOnly={true}
                            />
                            {getDraftContentStats(customer.customerNote.customerNote, 'words') > 500 ? (
                              <>
                                <u
                                  style={{
                                    cursor: "pointer",
                                    fontStyle: "italic",
                                    marginBottom: "14px",
                                    display: "inline-block",
                                  }}
                                  onClick={() =>
                                    showFullDescription(
                                      JSON.parse(
                                        customer.customerNote.customerNote,
                                      ),
                                    )
                                  }
                                >
                                  {t("READ_MORE")}
                                </u>
                              </>
                            ) : (
                              ""
                            )} */}
                            {(() => {
                              // Normalize to the inner DraftJS raw JSON string (supports both formats)
                              let noteRaw = customer.customerNote.customerNote;
                              try {
                                const parsed = JSON.parse(String(noteRaw));
                                if (parsed && typeof parsed === "object" && typeof parsed.customerNote === "string") {
                                  noteRaw = parsed.customerNote;
                                }
                              } catch (e) {}

                              // Convert DraftJS raw to plain text (first blocks joined by newline)
                              let plain = "";
                              try {
                                const raw = JSON.parse(String(noteRaw));
                                if (raw && Array.isArray(raw.blocks)) {
                                  plain = raw.blocks.map(b => b.text || "").join("\n").trim();
                                }
                              } catch (e) {
                                plain = "";
                              }

                              return (
                                <>
                                  <div
                                    style={{
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word"
                                    }}
                                    title={plain}
                                  >
                                    {plain}
                                  </div>
                                  {getDraftContentStats(noteRaw, 'words') > 500 ? (
                                    <>
                                      <u
                                        style={{
                                          cursor: "pointer",
                                          fontStyle: "italic",
                                          marginBottom: "14px",
                                          display: "inline-block",
                                        }}
                                        onClick={() => showFullDescription(noteRaw)}
                                      >
                                        {t("READ_MORE")}
                                      </u>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              );
                            })()}
                          </>
                        ))
                      }
                    </TableCell>
                    <TableCell style={{ verticalAlign: "top" }}>
                      {customer.firstName ? customer.firstName : ""}&nbsp;
                      {customer.lastName ? customer.lastName : ""}
                      {customer.firstName || customer.lastName ? (
                        <>
                          <br />
                        </>
                      ) : (
                        ""
                      )}
                      {customer.mobilePhone ? (
                        <>
                          {customer.mobilePhone}
                          <br />
                        </>
                      ) : (
                        ""
                      )}
                      {customer.email ? customer.email : ""}
                      <br />
                      {customer.attrRole ? "Role: " + customer.attrRole : ""}
                    </TableCell>
                    {/* <TableCell>{customer.attrRole}</TableCell>
                                    <TableCell>{customer.email}</TableCell> */}
                    { props.pathname === "/manageLeads" && 
                      <TableCell style={{ verticalAlign: "top" }}>
                        {customer.attrSector}
                      </TableCell> 
                    }
                    <TableCell style={{ verticalAlign: "top", whiteSpace: "pre-line" }}>
                      { props.pathname === "/manageLeads" ? 
                      (customer.shipping &&
                        customer.shipping.length > 0 &&
                        customer.shipping[0].city) : 
                        (formatShippingAddress(customer.shipping, props.countriesList, stateNamesMap))}
                    </TableCell>
                    {/* <TableCell>{customer.mobilePhone}</TableCell> */}
                    <TableCell style={{ verticalAlign: "top" }}>
                      {props.providerType === "SALES_CHNL_PROVIDER" && (
                        <>
                          {props.menuPaths.includes("/newOrder/:id") &&
                            props.userPerms.includes(
                              "ORDERMGR_SALES_CREATE",
                            ) && (
                              <Button
                                // className={classes.button1}
                                className={"buttonSecondary"}
                                // onClick={() => {
                                //     navigate({
                                //         pathname: `/newOrder/${props.product.productOfferingId}`,
                                //         state: {
                                //             subsciptionData: props.subsciptionData ? props.subsciptionData : {},
                                //             offeringCustomer: props.product.isBundle ? "" : props.offeringCustomer,
                                //             availableCustomers: props.availableCustomers ? props.availableCustomers : [],
                                //         },
                                //     });
                                // }}
                                style={{ whiteSpace: "nowrap" }}
                                onClick={(e) => {
                                  if (props.pathname === "/manageLeads") {
                                    props.createLeadQuote(e, customer);
                                  } else {
                                    props.createCustomerQuote(e, customer);
                                  }
                                }}
                              >
                                <span style={{ marginRight: "8px" }}>
                                  <svg
                                    width="13"
                                    height="12"
                                    viewBox="0 0 13 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_36_5803)">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M2.48535 1.50001H1.95508C1.67894 1.50001 1.45508 1.27615 1.45508 1.00001C1.45508 0.723863 1.67894 0.500006 1.95508 0.500006H2.5793C2.58292 0.500006 2.5866 0.500004 2.59033 0.500003C2.64651 0.499981 2.71428 0.499955 2.77426 0.504725C2.84429 0.510295 2.94332 0.524533 3.04814 0.575493C3.18483 0.641948 3.29811 0.748366 3.37296 0.880649C3.43036 0.982087 3.45075 1.08003 3.46067 1.14958C3.46918 1.20914 3.47338 1.27678 3.47686 1.33285C3.47709 1.33658 3.47732 1.34025 3.47755 1.34386L3.51855 2.00001L11.5207 2C11.5868 1.99998 11.6641 1.99995 11.7316 2.0057C11.8087 2.01226 11.9219 2.0292 12.0382 2.09342C12.1869 2.17546 12.3032 2.30549 12.3684 2.46224C12.4193 2.58495 12.4237 2.69938 12.4217 2.77666C12.4199 2.84443 12.4114 2.9213 12.4041 2.98694L12.1082 5.6498C12.0819 5.88619 12.0591 6.0914 12.027 6.26023C11.9928 6.43941 11.9419 6.61542 11.8398 6.78237C11.6864 7.03331 11.4626 7.23362 11.1963 7.35838C11.0191 7.44138 10.8385 7.47256 10.6567 7.4867C10.4853 7.50002 10.2788 7.50001 10.041 7.50001H3.8623L3.9248 8.50001H10.4551C10.7312 8.50001 10.9551 8.72386 10.9551 9.00001C10.9551 9.27615 10.7312 9.50001 10.4551 9.50001L3.81984 9.50001C3.76366 9.50003 3.69588 9.50006 3.6359 9.49529C3.56587 9.48972 3.46684 9.47548 3.36202 9.42452C3.22533 9.35806 3.11205 9.25165 3.0372 9.11936C2.9798 9.01793 2.95941 8.91998 2.94948 8.85043C2.94098 8.79087 2.93678 8.72323 2.9333 8.66716C2.93307 8.66343 2.93284 8.65976 2.93261 8.65615L2.48535 1.50001ZM2.47949 1.40624L2.52291 1.40353C2.53884 1.42401 2.55787 1.44188 2.5793 1.45651C2.58933 1.46335 2.59989 1.46949 2.61091 1.47484C2.63679 1.48743 2.65979 1.49441 2.67624 1.49815C2.6885 1.50094 2.6961 1.50168 2.6961 1.50168L2.69498 1.50158M3.7998 6.50001H10.023C10.284 6.50001 10.4512 6.49966 10.5792 6.48971C10.7009 6.48024 10.7477 6.46422 10.7721 6.4528C10.8609 6.41121 10.9355 6.34444 10.9866 6.2608C11.0007 6.23783 11.0218 6.19306 11.0446 6.07309C11.0686 5.94703 11.0875 5.78085 11.1163 5.52148L11.3964 3.00001H3.58105L3.7998 6.50001ZM3.95508 10.75C3.95508 10.3358 4.29086 10 4.70508 10C5.11929 10 5.45508 10.3358 5.45508 10.75C5.45508 11.1642 5.11929 11.5 4.70508 11.5C4.29086 11.5 3.95508 11.1642 3.95508 10.75ZM8.45508 10.75C8.45508 10.3358 8.79086 10 9.20508 10C9.61929 10 9.95508 10.3358 9.95508 10.75C9.95508 11.1642 9.61929 11.5 9.20508 11.5C8.79086 11.5 8.45508 11.1642 8.45508 10.75Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_36_5803">
                                        <rect
                                          width="12"
                                          height="12"
                                          fill="white"
                                          transform="translate(0.955078)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>
                                {props.quoteEnabled ? (
                                  <>{t("CREATE_QUOTE")}</>
                                ) : (
                                  <>{t("PLACE_ORDER")}</>
                                )}
                              </Button>
                            )}
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    { props.pathname === "/manageLeads" ? t("NO_LEADS_FOUND") : t("NO_CUSTOMERS_FOUND")}
                  </TableCell>
                </TableRow>
              )
            })()}
            </TableBody>
          </Table>
        </TableContainer>
        {props.totalRowsCount > 0 && (
          <div
            className="global-custom-pagination"
            style={{ background: "rgba(196, 196, 196, 0.2)" }}
          >
            <label style={{ float: "left", padding: "5px" }}>
              {t("TOTAL_RECORDS")}: {formatNumber(props.totalRowsCount)}
            </label>
            <label>
              {/* Rows per page select */}
              {props.t("ROWS_PER_PAGE")}
              <Select
                value={props.rowsPerPage}
                onChange={props.handleChangeRowsPerPage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </label>
            {/* Pagination component */}
            <Pagination
              count={Math.ceil(props.totalRowsCount / props.rowsPerPage)}
              onChange={props.handleChangePage}
              page={props.page}
              showFirstButton
              showLastButton
            />
          </div>
        )}
      </Card>
      {showDescription && (
        <ShowFullEditorContent
          open={showDescription}
          close={closeDescriptionDialog}
          data={descriptionData}
          t={props.t}
        />
      )}
    </React.Fragment>
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    countriesList: state.global.countriesList,
    defaultCountry: state.auth.defaultCountry,
    loggedInUserId: state.auth.loggedInUserId,
    showMyCustomers: state.auth.showMyCustomers,
    quoteEnabled: state.auth.quoteEnabled,
    providerType: state.auth.providerType,
    publicBrowsing: state.auth.publicBrowsing,
    userPerms: state.auth.userPerms,
    menuPaths: state.auth.menuPaths,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ManageCustomerTableView));
